<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="radioButtonValue"
	
	[label]="step2.getspan13"
	[type]="'radio'"
	[rule]="'pattern_29|required'"
	[errorMessage]="{'required' : 'ctr_1088'}"
	[radios]="[
		{
			label: step2.exigee,
			value: exigeeValue
		},
		{
			label: step2.autorisee,
			value: autoriseeValue
		},
		{
			label: step2.interdite,
			value: interditeValue
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input>
